import { parse, isValid } from 'date-fns';
import { enGB } from 'date-fns/locale';

export const isValidDate = (dateStr: string) => {
  const parsed = parse(dateStr, 'yyyy-MM-dd', new Date(), { locale: enGB });
  return isValid(parsed);
};

export const dateMessage = 'Data inválida';
